var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"price-chart"}},[_c('v-chart',{attrs:{"options":_vm.graph}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }